// extracted by mini-css-extract-plugin
export default {"link":"sidebar_link__Ygs3e","text":"sidebar_text__Z+xUe"};